module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-09.85c3ba1c.png";